import { frontendURL } from '../../../helper/URLHelper';
import TablesIndex from './pages/TablesIndex.vue';
import TableDetail from './pages/TableDetail.vue';

// `dotchatModule` is enforced twice: by the router guard before the route
// renders, and by the sidebar provider when deciding whether to show the nav
// entry at all. `tables_manage` gates module access for accounts using Custom
// Roles — which tables a user may actually read stays a per-table grant.
const commonMeta = {
  permissions: ['administrator', 'agent', 'tables_manage'],
  dotchatModule: 'tables',
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tables'),
    component: TablesIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'tables_index',
        component: TablesIndex,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/tables/:tableId'),
    name: 'tables_detail',
    component: TableDetail,
    meta: commonMeta,
  },
];
